export default {"src":"/_next/static/media/sign-up.cda89e9c.svg","height":610,"width":648};